import React from 'react';

import { cn } from '@workspace/ui/lib/utils';

import { company } from '~/company/Company';
import { useStatusBarControl } from '~/hooks/useStatusBarControl';

// I'm not sure why, but it's not working with ComponentPropsWithRef<'header'>
type EmptyHeaderProps = React.HTMLAttributes<HTMLHeadingElement>;

const EmptyHeader = React.forwardRef<HTMLHeadingElement, EmptyHeaderProps>(
  (props, ref) => {
    useStatusBarControl({
      initialColor: company.match({
        mcosmetic: 'dark-content',
        cerise: 'dark-content',
        default: 'light-content',
      }),
      scrolledColor: 'dark-content',
      scrollThreshold: 50,
    });

    return (
      <header
        {...props}
        ref={ref}
        className={cn(
          'h-auto w-full',
          company.match({
            mcosmetic: 'min-h-0 bg-bg-base pt-safe',
            heimkaup: 'min-h-4 bg-navigation-bg pt-safe-offset-4',
            cerise: 'min-h-4 bg-[var(--mobile-header-bg)] pt-safe-offset-4',
            circlek: 'min-h-4 bg-navigation-bg pt-safe-offset-4',
            localee: 'min-h-4 bg-navigation-bg pt-safe-offset-4',
            default: 'min-h-4 bg-graphic-regular-black pt-safe-offset-4',
          }),
          props.className,
        )}
      />
    );
  },
);
EmptyHeader.displayName = 'EmptyHeader';

export default EmptyHeader;
